import { Link } from "react-router-dom";
import { works } from "@/mocks/comics";
import SectionHeading from "@/components/feature/SectionHeading";
import ComicCard from "@/components/feature/ComicCard";

export default function HotWorks() {
  const hot = [...works].filter((w) => w.hot).slice(0, 8);

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="热门作品"
          title="大家都在追的连载"
          desc="根据追更人数与读者评分精选的热门作品，覆盖热血、奇幻、治愈等热门题材。"
          action={
            <Link
              to="/works"
              className="whitespace-nowrap rounded-full px-5 py-2.5 text-sm font-semibold text-primary-700 ring-1 ring-primary-200 transition-colors hover:bg-primary-100"
            >
              全部作品 <i className="ri-arrow-right-line ml-1" aria-hidden="true" />
            </Link>
          }
        />

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-5 lg:grid-cols-4">
          {hot.map((w) => (
            <ComicCard key={w.id} work={w} />
          ))}
        </div>
      </div>
    </section>
  );
}